import React from 'react';
import { Route, Switch } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ListPage from './pages/ListPage';
import Vineyard from './pages/Vineyard';
import SinglePageItem from './pages/SinglePageItem';
import PageNotFound from './pages/PageNotFound';
import { BrandUtil, BrandThemeProvider, PageLayerProvider } from 'dw-us-ui';
import styled from '@emotion/styled';

const MainContainer = styled.div`
  h3 {
    font-family: ${({ brandTag }) => (brandTag === 'law' ? 'Noto Serif' : 'georgia')};
    .osw & {
      font-family: 'Neue-aachen-pro';
    }
  }
`;

const App = () => {
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  return (
    <BrandThemeProvider brandTag={WEBPACK_BRAND_TAG}>
      <MainContainer brandTag={brandTag}>
        <PageLayerProvider>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/:path" component={SinglePageItem} />
            <Route path="/list" component={ListPage} />
            <Route path="/vineyard" component={Vineyard} />
            <Route component={PageNotFound} />
          </Switch>
        </PageLayerProvider>
      </MainContainer>
    </BrandThemeProvider>
  );
};

export default App;
